import { Grid2 } from '@mui/material';

import { styled } from '@/shared/ui';

export const StyledContainer = styled(Grid2)(() => ({
  marginBottom: '10px',
}));

export const StyledFirstCell = styled(Grid2)(() => ({
  width: '400px',
  marginRight: '30px',
}));

export const StyledSecondCell = styled(Grid2)(() => ({
  width: '240px',
}));
